<template>
<div style="margin-bottom:3rem">

  <!-- DIALO  WITH OPTIONS  -->
  <v-dialog width="1000" v-model="show">
    <v-btn color="primary" slot="activator">
      {{ $t('related.new_group') }}
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('related.new_group') }}
      </v-card-title>
      <v-container>
        <v-form ref="form" v-model="valid" v-on:submit="save">
          <v-flex xs8>
            <v-text-field v-model="name" :rules="nameRules" :label="`${$t('related.name')}`" required></v-text-field>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="code" :rules="nameRules" :label="`${$t('related.code')}`" required></v-text-field>
          </v-flex>
          <v-flex xs8>
            <v-select v-model="relatedGroupType" :items="relatedGroupTypes" :label="`${$t('related.group_type')}`"
                      item-text="name" item-value="id" required
                      @change="loadValues(relatedGroupType)"></v-select>
          </v-flex>
          <v-flex xs8>
            <v-select v-model="relatedValues" :items="relatedSchemaValues" :label="`${$t('related.values')}`" chips
                      hint="Wybierz wartosci" item-text="name"
                      item-value="id" multiple persistent-hint></v-select>
          </v-flex>

          <v-btn type="submit">
            {{ $t('archive.filter.save') }}
          </v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
  <!-- END DIALOG -->

</div>
</template>
<script>
import http from '@/plugins/http'

export default {
  components: {},
  data() {
    return {
      name: "",
      code: "",
      relatedValues: [],
      relatedGroupType: {},
      valid: false,
      nameRules: [
        v => !!v || this.$t('validator.blank'),
        v => !!v && (v.length <= 100 && v.length > 1) || this.$t('validator.wrong_length'),
      ],
      show: false
    }
  },
  computed: {
    relatedGroupTypes() {
      return this.$store.state.relatedGroupTypes
    },
    relatedSchemas() {
      return this.$store.state.relatedSchemas
    },
    relatedSchemaValues() {
      let valuesType = this.$store.getters.relatedValuesType(this.relatedGroupType)
      return valuesType != undefined ? valuesType.values : []
    },
  },
  created() {
    this.loadRelatedSchemas()
    this.loadRelatedGroupTypes()
  },
  methods: {
    save(e) {
      e.preventDefault();
      if (this.valid) {
        http.post('related/group ', this.getPayload())
          .then((data) => {
            this.$emit("created", data.data)
            this.$refs.form.reset()
            this.show = false;
            this.showMessage(this.$t('related.created'), "success")
          })
          .catch(() => this.showMessage(this.$t('related.cannot_create'), "danger"))
      }
    },
    getPayload() {
      let payload = {}
      payload.name = this.name
      payload.code = this.code
      payload['type_id'] = this.relatedGroupType
      payload['related_values_id'] = this.relatedValues
      return payload;
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    },
    loadValues(relatedGroupTypeId) {
      this.relatedValues = []
      this.$store.dispatch("loadValuesType", {
        idType: relatedGroupTypeId
      })
    },
    loadRelatedSchemas() {
      if (this.relatedSchemas.length == 0)
        return this.$store.dispatch('loadRelatedSchemas')
    },
    loadRelatedGroupTypes() {
      if (this.relatedGroupTypes.length == 0)
        return this.$store.dispatch('loadRelatedGroupTypes')
    }
  },
}
</script>

<style>

</style>
